// Состояние «Матчей», общее для серверной шапки (LIVE, календарь) и самого экрана (вкладки дней, группы).
// Живёт в модуле: переживает уход на экран матча и возврат (вкладка монтируется заново).
// Выбранный день помнит местную дату выбора: наступило другое «сегодня» — день сброшен к якорю сервера (HQ-1821).
import { useSyncExternalStore } from 'react';
import { localDate, subscribeLocalToday } from './useLocalToday';

export interface MatchesUi {
  liveOnly: boolean;
  /** Поле строки для фильтра LIVE — action.field кнопки серверной шапки (сегодня is_live). */
  liveField: string;
  /** Выбранный день (YYYY-MM-DD); null — серверный anchor. */
  day: string | null;
  calendarOpen: boolean;
}

/** Состояние модуля: плюс местная дата, в которую выбран day. */
export interface MatchesUiState extends MatchesUi { dayChosenOn: string | null }

let state: MatchesUiState = { liveOnly: false, liveField: 'is_live', day: null, calendarOpen: false, dayChosenOn: null };
const listeners = new Set<() => void>();

/** Выбор дня из другого «сегодня» — снят (якорь сервера). Не изменилось — тот же объект. */
export function freshMatchesUi(s: MatchesUiState, today: string): MatchesUiState {
  return s.day !== null && s.dayChosenOn !== today ? { ...s, day: null, dayChosenOn: null } : s;
}

/** Текущее состояние; устаревший выбор дня сбрасывается в самом модуле (следующие чтения — тот же объект). */
export function matchesUiSnapshot(): MatchesUiState {
  state = freshMatchesUi(state, localDate());
  return state;
}

export function setMatchesUi(patch: Partial<MatchesUi>): void {
  state = { ...state, ...patch };
  if ('day' in patch) state.dayChosenOn = patch.day == null ? null : localDate();
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  const offToday = subscribeLocalToday(listener);
  return () => { listeners.delete(listener); offToday(); };
}

export function useMatchesUi(): MatchesUi {
  return useSyncExternalStore(subscribe, matchesUiSnapshot, matchesUiSnapshot);
}
